module.exports = __webpack_public_path__ + "static/media/sitrack_color.22c61360.svg";